import type { AuthRepositoryPort, LoginCredentials } from "../ports/auth.repository.port";

export function cancelAccountDeletionWithPasswordUseCase(repository: AuthRepositoryPort, credentials: LoginCredentials) {
  return repository.cancelAccountDeletionWithPassword(credentials);
}
